import { ArrowCap } from "../../../types/Enum";
import { Coord } from "../../../types/Interface";
import getAngleBetweenPoints from "../../../utils/math/getAngleBtwPoints";
import getCenterOfTwoCoords from "../../../utils/coord/getCenterOfTwoCoords";
import getDistanceBtwPoints from "../../../utils/getDistanceBtwPoints";


function getArrowCapCoord(
  coordStart: Coord,
  coordEnd: Coord,
  cap: ArrowCap.Start | ArrowCap.End,
  H_LENGTH = 20,
  V_LENGTH = 25
) {

  const radian = getAngleBetweenPoints(coordStart, coordEnd);
  const capCoord = cap === ArrowCap.Start ? coordStart : coordEnd;
  const horizontalR = radian + (cap === ArrowCap.Start ? Math.PI / 2 : -Math.PI / 2);
  const verticalR = cap === ArrowCap.Start ? radian - Math.PI : radian;

  const firstCoord = {
    x: capCoord.x + Math.cos(horizontalR) * H_LENGTH / 2,
    y: capCoord.y + Math.sin(horizontalR) * H_LENGTH / 2
  }

  const secondCoord = {
    x: capCoord.x + Math.cos(verticalR) * V_LENGTH,
    y: capCoord.y + Math.sin(verticalR) * V_LENGTH
  }

  const thirdCoord = {
    x: capCoord.x - Math.cos(horizontalR) * H_LENGTH / 2,
    y: capCoord.y - Math.sin(horizontalR) * H_LENGTH / 2
  }

  return [firstCoord, secondCoord, thirdCoord];
}

export function getEqualSymbolCoords(coordStart: Coord, coordEnd: Coord) {
  const length = 18;
  const radian = getAngleBetweenPoints(coordStart, coordEnd) + Math.PI / 2;
  const centerCoord = getCenterOfTwoCoords(coordStart, coordEnd);
  const coord1 = {
    x: Math.cos(radian) * (length / 2) + centerCoord.x,
    y: Math.sin(radian) * (length / 2) + centerCoord.y
  }
  const coord2 = {
    x: Math.cos(radian) * (-length / 2) + centerCoord.x,
    y: Math.sin(radian) * (-length / 2) + centerCoord.y
  }
  return [coord1, coord2];
}

export function getArrowCapsCoords(coordStart: Coord, coordEnd: Coord, cap: ArrowCap): Coord[][] {
  if (cap === ArrowCap.None) return []
  else if (cap === ArrowCap.Both) return [
    getArrowCapCoord(coordStart, coordEnd, ArrowCap.Start),
    getArrowCapCoord(coordStart, coordEnd, ArrowCap.End)
  ];
  else return [getArrowCapCoord(coordStart, coordEnd, cap)];
}

export function getArrowSymbolCoords(coordStart: Coord, coordEnd: Coord): Coord[] {
  const centerCoord = getCenterOfTwoCoords(coordStart, coordEnd);
  return getArrowCapCoord(coordStart, centerCoord, ArrowCap.End, 20, 20);
}

export function genDashedCoords(coordStart: Coord, coordEnd: Coord) {
  let dashedCoords: Coord[] = [];
  const lineLength = 20;
  const radian = getAngleBetweenPoints(coordStart, coordEnd);
  const lineCount = Math.ceil(getDistanceBtwPoints(coordStart, coordEnd) / lineLength);

  for (let i = 0; i < lineCount; i++) {
    const startCoord = dashedCoords.length > 0 ? dashedCoords[dashedCoords.length - 1] : coordStart;
    const _x = startCoord.x + Math.cos(radian) * lineLength;
    const _y = startCoord.y + Math.sin(radian) * lineLength;
    const newCoord = i !== lineCount - 1 ? { x: _x, y: _y } : coordEnd;
    dashedCoords.push(newCoord);
  }
  return dashedCoords;
}


export function getCoordsForArrowCaps(_coordStart: Coord, _coordEnd: Coord) {
  const radian = getAngleBetweenPoints(_coordStart, _coordEnd);
  const coordStart = {
    x: _coordStart.x + Math.cos(radian) * 25,
    y: _coordStart.y + Math.sin(radian) * 25
  };
  const coordEnd = {
    x: _coordEnd.x - Math.cos(radian) * 25,
    y: _coordEnd.y - Math.sin(radian) * 25
  }
  return { coordStart, coordEnd };
}